import React from "react";
import _ from "lodash";

import OtherAssetsPage from "./index";

const OtherAssetsCustomerPage = (props) => {
  const defaultTab = React.useMemo(() => {
    const searchParams = _.get(props, 'location.search');
    return new URLSearchParams(searchParams).get('view') || undefined;
  }, []);

  return (
    <div style={{background: 'white', height: '100%', overflow: 'auto', '--main-page-height': '100%'}}>
      <OtherAssetsPage
        customerId={props.auth.user.customer_id}
        defaultTab={defaultTab}
        isCustomerApp
      />
    </div>
  )
};

export default OtherAssetsCustomerPage;